import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listMyRequests } from "@/lib/account.functions";
import { Wrench } from "lucide-react";

export const Route = createFileRoute("/_authenticated/konto/mina-forfragningar")({
  component: MyRequestsPage,
});

function MyRequestsPage() {
  const fn = useServerFn(listMyRequests);
  const { data, isLoading } = useQuery({ queryKey: ["my-requests"], queryFn: () => fn() });

  if (isLoading) return <div className="rounded-3xl border border-border bg-card p-8">Laddar…</div>;
  const list = data?.requests ?? [];

  return (
    <div className="rounded-3xl border border-border bg-card p-6 md:p-8 elev-shadow">
      <h2 className="font-display text-2xl">Mina reservdelsförfrågningar</h2>
      {list.length === 0 ? (
        <p className="mt-4 text-sm text-muted-foreground">Du har inte skickat några förfrågningar än.</p>
      ) : (
        <ul className="mt-6 divide-y divide-border">
          {list.map((r) => (
            <li key={r.id} className="py-5">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <div>
                  <p className="font-display text-lg">
                    {r.brand ?? "—"} {r.model ? `· ${r.model}` : ""}
                  </p>
                  <p className="mt-0.5 text-xs uppercase tracking-wider text-muted-foreground">
                    {new Date(r.created_at).toLocaleString("sv-SE")}
                    {r.reg_number ? ` · ${r.reg_number}` : ""}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent/10 px-3 py-1 text-xs font-medium text-accent">
                  <Wrench size={12} /> {r.status}
                </span>
              </div>
              {r.categories && r.categories.length > 0 && (
                <p className="mt-2 text-xs text-muted-foreground">Kategorier: {r.categories.join(", ")}</p>
              )}
              {r.message && <p className="mt-2 text-sm text-foreground/85">{r.message}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
